import { Edit } from 'react-admin';
import { QuickReplyForm } from './index';
import { EditToolbar } from '@components/EditToolbar';

export const QuickReplyEdit = () => (
  <Edit mutationMode="pessimistic">
    <QuickReplyForm toolbar={<EditToolbar />} />
  </Edit>
);
